import pexelsService from '../../../services/pexelsService';

const mediaService = {
  async searchMedia({ q, type = 'photo', page = 1, orientation = '' }) {
    const params = {
      q: q || 'marketing',
      page: String(page || 1),
      orientation,
    };

    const result = type === 'video'
      ? await pexelsService.searchVideos(params)
      : await pexelsService.searchPhotos(params);

    if (!result?.success) {
      return {
        items: [],
        page: Number(result?.page || 1),
        has_more: false,
        message: result?.message || 'Não foi possível carregar imagens',
      };
    }

    return {
      items: Array.isArray(result.items) ? result.items : [],
      page: Number(result.page || 1),
      has_more: Boolean(result.has_more),
    };
  },
};

export default mediaService;
